import type { NativeStringStore } from '../persistence/recovery-controller';

/** Native promises are not cancellable. A timed-out write stays fenced until it settles. */
export function boundedNativeStore(store: NativeStringStore, timeoutMs = 15_000): NativeStringStore {
  let pendingWrite: Promise<void> | null = null;
  function bounded<T>(operation: Promise<T>): Promise<T> {
    return new Promise((resolve, reject) => {
      const timer = setTimeout(() => reject(new Error('기기 복구 사본의 응답을 아직 확인하지 못했어요. 원본은 그대로이며 잠시 후 다시 확인해주세요.')), timeoutMs);
      operation.then((value) => { clearTimeout(timer); resolve(value); }, () => { clearTimeout(timer); reject(new Error('기기 복구 사본 저장소에서 작업을 마치지 못했어요.')); });
    });
  }
  function write(operation: () => Promise<void>): Promise<void> {
    if (pendingWrite) return Promise.reject(new Error('앞선 사본 작업이 아직 끝나지 않았어요. 중복 저장·삭제를 시작하지 않고 기다리고 있습니다. 잠시 후 다시 확인해주세요.'));
    const pending = Promise.resolve().then(operation);
    pendingWrite = pending;
    // Clear only this exact operation; do not treat the timeout as native cancellation.
    void pending.then(() => { if (pendingWrite === pending) pendingWrite = null; }, () => { if (pendingWrite === pending) pendingWrite = null; });
    return bounded(pending);
  }
  return { getItem: (key) => bounded(Promise.resolve().then(() => store.getItem(key))), setItem: (key, value) => write(() => store.setItem(key, value)), removeItem: (key) => write(() => store.removeItem(key)) };
}
